import { BREAKPOINTS, COLORS, HorizontalCard, SystemIcons } from "@laerdal/life-react-components";
import { ReactNode } from "react";
import styled from "styled-components";

const CardDescription = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 1.25;
`;
const MobileCardDescription = styled.div`
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;
const LinkText = styled.div`
    gap: 8px;
    min-height: 24px;
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    color: ${COLORS.primary_600};
    margin-top: 16px;
`;
const CardTitle = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    ${BREAKPOINTS.MEDIUM}{
        font-size: 20px;
        line-height: normal;
    }

     ${BREAKPOINTS.LARGE}{
        margin-bottom: 8px;
    }
`;

const ProductResourceCard = ({
  isMobile,
  title,
  description,
  linkText,
  action,
  id,
}: {
  isMobile: boolean,
  title: {
    icon?: ReactNode,
    text: string,
  },
  description: string,
  linkText: string,
  action: () => void,
  id?: string,
}) => {
  return (
    <HorizontalCard
      id={id}
      title={
        <CardTitle>
          {title.icon}
          {title.text}
        </CardTitle>}
      description={
      isMobile
        ? <MobileCardDescription>{description}</MobileCardDescription>
        : <CardDescription>
          {description}
          <LinkText>
            {linkText}
            <SystemIcons.ArrowLineRight color={COLORS.primary_600} />
          </LinkText>
        </CardDescription>}
      action={action}
      actions={isMobile ? [{
        componentType: 'icon',
        icon: <SystemIcons.ChevronRight color={COLORS.primary_600} />,
        action: action
      }] : undefined}
    />);
};

export default ProductResourceCard;